module.exports = __webpack_public_path__ + "static/img/allchat.358928c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pdd/allchat.png
// module id = 1212
// module chunks = 0